<aside class="sidebar" [class.collapsed]="isCollapsed()" [class.mobile-open]="isMobileMenuOpen()">
    <!-- Top: Brand + Collapse -->
    <div class="side-top">
        <div class="brand">
            @if (logoPath) {
                <img [src]="logoPath" alt="logo" class="logo-icon" />
            } @else {
                <i class="brand-mark"></i>
            }
            <span class="brand-text">
                {{ logoText }}
                <small>Admin Portal</small>
            </span>
        </div>
        <button class="collapse-btn" (click)="toggleCollapse()" aria-label="Collapse menu">
            <span class="material-icons-outlined">chevron_left</span>
        </button>
    </div>

    <!-- Menu Scroll Area -->
    <div class="menu-scroll">
        @for (group of menuGroups(); track group.label) {
            <div class="menu-label">{{ group.label }}</div>
            <nav class="nav">
                @for (item of group.items; track item.label) {
                    @if (!item.hide) {
                        @if (!item.children) {
                            <a
                                [routerLink]="item.route"
                                routerLinkActive="active"
                                [routerLinkActiveOptions]="{ exact: true }"
                                class="nav-link"
                                (click)="closeMobileMenu()"
                            >
                                <span class="nav-icon material-icons-outlined">{{ item.icon }}</span>
                                <span class="nav-text">{{ item.label }}</span>
                            </a>
                        } @else {
                            <button
                                (click)="toggleSubmenu(item)"
                                class="nav-link nav-accordion-trigger"
                                [class.expanded]="item.expanded"
                            >
                                <span class="nav-icon material-icons-outlined">{{ item.icon }}</span>
                                <span class="nav-text">{{ item.label }}</span>
                                <span class="nav-arrow material-icons-outlined">expand_more</span>
                            </button>
                            @if (item.expanded) {
                                <div class="nav-submenu">
                                    @for (child of item.children; track child.label) {
                                        @if (!child.hide) {
                                            <a
                                                [routerLink]="child.route"
                                                routerLinkActive="active"
                                                [routerLinkActiveOptions]="{ exact: true }"
                                                class="nav-link nav-sublink"
                                                (click)="closeMobileMenu()"
                                            >
                                                <span class="nav-text">{{ child.label }}</span>
                                            </a>
                                        }
                                    }
                                </div>
                            }
                        }
                    }
                }
            </nav>
        }
    </div>

    <!-- Profile -->
    <div class="profile">
        <div class="profile-avatar">{{ userInitials() }}</div>
        <div class="profile-copy">
            <strong>{{ userInfo()?.name || userInfo()?.userName || 'User' }}</strong>
            <span>{{ userInfo()?.roles?.[0]?.explation || 'Administrator' }}</span>
        </div>
        <button class="logout-btn" (click)="logout()" aria-label="Logout">
            <span class="material-icons-outlined">logout</span>
        </button>
    </div>
</aside>

<!-- Mobile Toggle Button -->
<button
    class="mobile-menu-toggle lg:hidden fixed top-4 left-4 z-50 bg-accent text-white rounded-lg p-2 shadow-lg"
    (click)="toggleMobileMenu()"
>
    <span class="material-icons-outlined">{{ isMobileMenuOpen() ? 'close' : 'menu' }}</span>
</button>

<!-- Mobile Overlay -->
@if (isMobileMenuOpen()) {
    <div class="mobile-overlay lg:hidden fixed inset-0 bg-black/50 z-40" (click)="closeMobileMenu()"></div>
}
